import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { SubscriptionService } from '../services/subscription.service';
import { subscriptionActions } from './subscription.actions';

@Injectable()
export class SubscriptionEffects {
    constructor(
        private actions$: Actions,
        private subscriptionService: SubscriptionService
    ) { }

    getSubscriptions$ = createEffect(() => this.actions$.pipe(
        ofType(subscriptionActions.getSubscriptions),
        switchMap(() => this.subscriptionService.getSubscriptions().pipe(
            map(subscriptions => subscriptionActions.getSubscriptionsSuccess(subscriptions)),
            catchError(error => of(subscriptionActions.getSubscriptionsFailure({ error: error.message })))
        ))
    ));

    getSubscription$ = createEffect(() => this.actions$.pipe(
        ofType(subscriptionActions.getSubscription),
        switchMap(action => this.subscriptionService.getSubscription(action.subscriptionId).pipe(
            map(subscription => subscriptionActions.getSubscriptionSuccess(subscription)),
            catchError(error => of(subscriptionActions.getSubscriptionFailure({ error: error.message })))
        ))
    ));
}
